export default __webpack_public_path__ + "static/5-410a6d38d50384b87c1b7da6ac7ef6a0.jpeg";